/**
 * Build with Customer Details Component
 * Main component that displays BwC Customers dashboard
 */

import React from "react";
import { Icon } from "@fluentui/react";
import { BwCCustomersTab } from "./BwCCustomersTab";
import { BUILD_WITH_CUSTOMER_STYLES } from "./BuildWithCustomer.styles";
import { IBuildWithCustomerDetailsProps } from "./BuildWithCustomer.interfaces";

export const BuildWithCustomerDetails: React.FC<IBuildWithCustomerDetailsProps> = ({ isLoading = false }) => {
  return (
    <div className={BUILD_WITH_CUSTOMER_STYLES.pageRoot}>
      {/* Page header with logo badge */}
      <div className={BUILD_WITH_CUSTOMER_STYLES.pageHeader}>
        <div className={BUILD_WITH_CUSTOMER_STYLES.headerLeft}>
          <div className={BUILD_WITH_CUSTOMER_STYLES.headerLogoBadge}>
            <Icon iconName="Contact" />
          </div>
          <div>
            <div className={BUILD_WITH_CUSTOMER_STYLES.pageHeaderTitle}>Purview BwC (Build With Customers)</div>
            <div className={BUILD_WITH_CUSTOMER_STYLES.pageHeaderSubtitle}>
              Built with Copilot - Program & Customer Tracking
            </div>
          </div>
        </div>
      </div>

      {/* BwC Customers Content */}
      <BwCCustomersTab isLoading={isLoading} />
    </div>
  );
};
